/**
 * The v1 wire envelope shared by every host carrier (iOS / Android / web parent).
 * One shape, three transports. See design doc 0006.
 */
export type Envelope =
  | { v: 1; kind: "request"; id: string; event: string; payload?: unknown }
  | { v: 1; kind: "response"; id: string; ok: true; result?: unknown }
  | { v: 1; kind: "response"; id: string; ok: false; error: BridgeErrorShape }
  | { v: 1; kind: "event"; event: string; payload?: unknown };

export interface BridgeErrorShape {
  code: "unsupported_event" | "bad_payload" | "host_error" | "timeout" | "version_mismatch";
  message: string;
}

/** Error thrown/rejected when a host call fails or times out. */
export class BridgeError extends Error {
  code: BridgeErrorShape["code"];

  constructor(err: BridgeErrorShape) {
    super(`${err.code}: ${err.message}`);
    this.name = "BridgeError";
    this.code = err.code;
  }
}
